import { IRange } from 'features/range-date/date-range-picker'

import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

interface Props {
  date: IRange
  difficultIndex: number
  segments: DifficultRoute[] | []
}

export const onRangeDifficultRoute = ({
  date,
  difficultIndex,
  segments,
}: Props) => {
  const parsedDate = Date.parse(date.startDate!)

  for (const indexSegment in segments) {
    const index = parseInt(indexSegment)

    if (index > difficultIndex) {
      if (Date.parse(segments[index].date!) < parsedDate) {
        segments[index].date = ''
      } else {
        continue
      }
    } else if (index === difficultIndex) {
      segments[index] = {
        from: segments[index]?.from,
        to: segments[index]?.to,
        date: date?.startDate,
      }
    }
  }

  return segments
}
